import React, { Component } from 'react';
import Loading from './Loading';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import '../css/Loan.css';

class LoanAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingShow: true,
            account: [],
            accountDetail: [],
            is_account: true,
            is_accountDetail: true
        }
        _isLogin().then(value => {
            if (value) this.getLoanAccount();
            this.getLoanAccountDetail();
        });
    }

    getLoanAccount() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('g    .php', param)
            .then(res => {
                //console.log('res', res)
                this.setState({ loadingShow: false, is_account: (res.data.status) ? true : false })
                if (res.data.status) {
                    this.setState({ account: res.data.data.loan });
                } else {
                    if (res.data.responseText === 101) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    }
                }
            }).catch(err => {
                this.setState({ loadingShow: false });
                _Alert('error');
            });
    }

    getLoanAccountDetail() {
        // let param = { token: _getToken(), platform: variable().platform, member_no: '002085' };
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.loan.account.detail.php', param)
            .then(res => {
                // console.log('res DEtail ', res)
                this.setState({ loadingShow: false, is_accountDetail: (res.status) ? true : false })
                if (res.status) {
                    console.log('res DEtail >>> ', res.data)
                    this.setState({ accountDetail: res.data });
                } else {
                    if (res.data.responseText === 101) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    }
                }
            }).catch(err => {
                this.setState({ loadingShow: false });
                _Alert('error');
            });
    }

    gotoTransaction(id) {
        window.location.href = variable().BASE_URL + "/online/loan/" + id;
    }
    gotoDoc(urlLinkDoc) {
        window.location.href = urlLinkDoc
    }

    renderLoanAccount() {
        return (
            <div>
                <table className="table table-loan">
                    <thead>
                        {
                            (this.state.account.length > 0) ?
                                <tr>
                                    <th scope="col">เลขสัญญา</th>
                                    <th scope="col">รายการ</th>
                                    <th scope="col">วงเงินกู้</th>
                                    <th scope="col">จำนวนงวด</th>
                                    <th scope="col">ชำระต่อเดือน</th>
                                    <th scope="col" className="text-center">คงเหลือ</th>
                                </tr>
                                :
                                null
                        }
                    </thead>
                    <tbody>
                        {
                            this.state.account.map(account => (
                                <tr key={account.id} onClick={(e) => this.gotoTransaction(account.id)}>
                                    <td>{account.contract_number}</td>
                                    <td>{account.loan_type}</td>
                                    <td>{account.loan_amount} บาท</td>
                                    <td>{account.period_amount}</td>
                                    <td>{account.pay_per_month}</td>
                                    <td className="text-right">{account.loan_amount_balance} บาท</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                <div className="mobile-loan-content">
                    {
                        this.state.account.map((account, index) => (
                            <div key={account.id} onClick={(e) => this.gotoTransaction(account.id)} className={(index === 0) ? 'is-first loan-loop' : 'loan-loop'}>
                                <div className="loan-row">
                                    <div className="loan-row-first"><span className="text-title">เลขสัญญา : </span><span className="text-desc">{account.contract_number}</span></div>
                                    <div className="loan-row-second"><span className="text-title">รายการ : </span><span className="text-desc">{account.loan_type}</span></div>
                                </div>
                                <div className="loan-row">
                                    <div className="loan-row-third"><span className="text-title">วงเงินกู้ : </span><span className="text-desc type-desc">{account.loan_amount} บาท</span></div>
                                    <div className="loan-row-fourt"><span className="text-title">จำนวนงวด : </span><span className="text-desc">{account.period_amount}</span></div>
                                </div>
                                <div className="loan-row">
                                    <div className="loan-row-third"><span className="text-title">ชำระต่อเดือน : </span><span className="text-desc type-desc">{account.pay_per_month}</span></div>
                                    <div className="loan-row-fourt"><span className="text-title">คงเหลือ : </span><span className="text-desc">{account.loan_amount_balance} บาท</span></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>


        )
    }

    renderLoanAccountDetail() {
        console.log(this.state.accountDetail)
        return (
            <div>
                <table className="table table-loan">
                    <thead>
                        {
                            (this.state.accountDetail.length > 0) ?
                                <tr>
                                    <th scope="col">วันที่ขอกู้</th>
                                    <th scope="col">เลขที่สัญญา</th>
                                    <th scope="col" className="text-center">สถานะ</th>
                                    <th scope="col" className="text-center">ดาวน์โหลดสัญญาเงินกู้</th>
                                </tr>
                                :
                                null
                        }
                    </thead>
                    <tbody>
                        {
                            this.state.accountDetail.map(accountDetail => (
                                <tr key={accountDetail.id} onClick={(e) => this.gotoDoc(accountDetail.link_doc)}>
                                    <td>{accountDetail.createdatetime}</td>
                                    <td>{accountDetail.contract_number}</td>
                                    <td className="text-center">{accountDetail.status}</td>
                                    <td className="text-center-sub">ดาวน์โหลด</td>

                                    {/* <td>{account.pay_per_month}</td>
                                    <td className="text-right">{account.loan_amount_balance} บาท</td> */}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                <div className="mobile-loan-content">
                    {
                        this.state.account.map((account, index) => (
                            <div key={account.id} onClick={(e) => this.gotoTransaction(account.id)} className={(index === 0) ? 'is-first loan-loop' : 'loan-loop'}>
                                <div className="loan-row">
                                    <div className="loan-row-first"><span className="text-title">เลขสัญญา : </span><span className="text-desc">{account.contract_number}</span></div>
                                    <div className="loan-row-second"><span className="text-title">รายการ : </span><span className="text-desc">{account.loan_type}</span></div>
                                </div>
                                <div className="loan-row">
                                    <div className="loan-row-third"><span className="text-title">วงเงินกู้ : </span><span className="text-desc type-desc">{account.loan_amount} บาท</span></div>
                                    <div className="loan-row-fourt"><span className="text-title">จำนวนงวด : </span><span className="text-desc">{account.period_amount}</span></div>
                                </div>
                                <div className="loan-row">
                                    <div className="loan-row-third"><span className="text-title">ชำระต่อเดือน : </span><span className="text-desc type-desc">{account.pay_per_month}</span></div>
                                    <div className="loan-row-fourt"><span className="text-title">คงเหลือ : </span><span className="text-desc">{account.loan_amount_balance} บาท</span></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>


        )
    }

    render() {
        return (
            <>
                <div className="card">
                    <Loading show={this.state.loadingShow} />
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                        <div className="card-title-text">เงินกู้</div>
                    </div>
                    <div className="card-content card-loan">
                        {this.state.is_account ? this.renderLoanAccount() : <div className="no-data">ไม่พบบัญชีเงินกู้</div>}
                    </div>
                </div>
                <div className="card">
                    {/* <Loading show={this.state.loadingShow} /> */}
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                        <div className="card-title-text">ดาวน์โหลดสัญญาเงินกู้</div>
                    </div>
                    <div className="card-content card-loan">
                        {this.state.is_accountDetail ? this.renderLoanAccountDetail() : <div className="no-data">ไม่พบเอกสารสัญญาเงินกู้</div>}
                    </div>
                </div>
            </>




        )

    }
}

export default LoanAccount;